/* eslint-disable no-console */
import store from "@/store";
import Infrastructure from "@/infrastructure";
const infra = new Infrastructure();
import useNotification from "@/composables/useNotification";
const { notify } = useNotification();

export default {
  namespaced: true,
  state: {
    climateProfileList: []
  },
  actions: {
    async loadClimateProfileList(s: any): Promise<void> {
      try {
        const response = await infra.climate.GetClimateProfileList();
        s.commit("addClimateProfileList", response.climateprofileList);
      } catch (error) {
        console.log("load climate profile list failed", error);
        store.commit("setNetworkError");
        notify(
          `Не удалось загрузить список профилей климата. Попробуйте еще раз`,
          "error"
        );
        throw error;
      }
    }
  },
  mutations: {
    addClimateProfileList(s: any, arr): void {
      s.climateProfileList = arr;
    }
  },
  getters: {
    getClimateProfileList: (s: any) => s.climateProfileList
  }
};
